export const BrokersData = ({
    method = "GET",
    id = null,
    query = {},
    formData = {},
}) => {
    let endpoint = "/brokers/";
    const normalizedQuery = { ...query };
    const rawUserData = localStorage.getItem("userData");
    const userData = rawUserData ? JSON.parse(rawUserData) : null;

    if ((method === "GET" || method === "DELETE") && id) {
        normalizedQuery.id = id;
    }

    if (method === "GET" && Object.keys(normalizedQuery).length > 0) {
        const params = new URLSearchParams(
            Object.fromEntries(
                Object.entries(normalizedQuery).filter(([_, value]) => value !== null && value !== undefined && value !== "")
            )
        ).toString();

        if (params) {
            endpoint += `?${params}`;
        }
    } else if (method === "DELETE" && id) {
        endpoint += `?id=${encodeURIComponent(id)}`;
    }

    const headers = {
        ...(formData instanceof FormData ? {} : { "Content-Type": "application/json" }),
    };

    if (userData?.token) {
        headers.Authorization = `Bearer ${userData.token}`;
    }

    return fetch(`${process.env.REACT_APP_BASE_URL}${endpoint}`, {
        method,
        credentials: "include",
        headers,
        body: ["POST", "PUT", "PATCH"].includes(method)
            ? (formData instanceof FormData ? formData : JSON.stringify(formData))
            : null,
    })
        .then(async (response) => {
            const json = await response.json().catch(() => ({}));
            const responseData = (() => {
                if (json && typeof json === "object") {
                    if (json.data && typeof json.data === "object" && !Array.isArray(json.data)) {
                        return json.data;
                    }

                    if (json.page !== undefined || json.total_pages !== undefined || json.visible_pages !== undefined) {
                        return json;
                    }
                }

                return json?.data ?? null;
            })();

            return {
                status: response.ok ? (json.status || "success") : (json.status || "error"),
                message: json.message || "Unknown error",
                code: json.code || response.status,
                data: responseData,
            };
        })
        .catch((error) => ({
            status: "error",
            message: error.message || "Service Unavailable",
            code: 503,
            data: null,
        }));
};
